module.exports = __webpack_public_path__ + "static/media/no_faq.22d3764e.png";